import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { MdAmpStories } from "react-icons/md";



export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: MdAmpStories,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig:     {
        group: 'Devices',
        name: "Fire damper with open and close signal",
        description: "Fire damper",
        panel: OverviewPanel,
    },
}